<template>
  <div>
    <e-sidebar
      :title="edit ? $t('Editar Marca') : $t('Nova Marca')"
      :show="showSidebar"
      :fetching="fetching"
      :saving="saving"
      width="500px"
      @save="saveBrand"
      @hidden="hideSidebar"
    >
      <template #content>
        <div>
          <FormulateForm
            ref="brandForm"
            name="form"
          >
            <FormulateInput
              id="brand-name"
              v-model="localBrand.name"
              type="text"
              class="required"
              :label="$t('Nome')"
              validation="required"
            />
            <FormulateInput
              id="brand-api-id"
              v-model="localBrand.apiId"
              type="number"
              class="required"
              :label="$t('Id API')"
              :instruction="$t('Id utilizado nas integrações com APIs externas')"
              validation="required"
            />
            <FormulateInput
              id="brand-manufacturer-id"
              v-model="localBrand.manufacturerId"
              type="vue-select"
              :label="$t('Fabricante')"
              :options="getComboManufactures"
            />
          </FormulateForm>
          <FormulateInput
            id="brand-image-local"
            v-model="imageLocal"
            type="uploader"
            deletable="true"
            max-files="1"
            :meta="false"
            :label="$t('Imagem')"
          />
        </div>
      </template>
    </e-sidebar>
  </div>
</template>

<script>
import { ESidebar } from '@/views/components'
import { uploader } from '@/mixins'
import { mapActions, mapGetters } from 'vuex'

const getInitialLocalBrand = () => ({
  id: null,
  apiId: null,
  name: '',
  image: '',
  active: null,
  manufacturerId: null,
})

export default {
  components: {
    ESidebar,
  },

  mixins: [uploader],

  props: {
    brandId: {
      type: Number,
      default: null,
    },
    brand: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showSidebar: false,
      fetching: false,
      edit: false,
      saving: false,
      localBrandId: null,
      localBrand: getInitialLocalBrand(),
      imageLocal: [],
    }
  },

  computed: {
    ...mapGetters('pages/catalog/products', ['getComboManufactures']),
  },

  watch: {
    brand(val) {
      this.localBrand = {
        ...val,
        manufacturerId: val.manufacturerId?.toString(),
      }
      this.imageLocal = val?.image ? [this.getFileInstance(val.image)] : []
    },
    brandId(val) {
      this.localBrandId = val
    },
    async localBrandId(val) {
      if (val) {
        try {
          this.fetching = true
          const { data: localBrand } = await this.$http.get(`/api/brands/${this.localBrandId}`)
          this.localBrand = {
            ...localBrand,
            manufacturerId: localBrand.manufacturerId?.toString(),
          }
          this.imageLocal = localBrand?.image ? [this.getFileInstance(localBrand.image)] : []
        } catch (error) {
          this.showGenericError({ error })
        } finally {
          this.fetching = false
        }
      } else {
        this.localBrand = {}
      }
    },
  },

  methods: {
    ...mapActions('pages/catalog/products', { comboFetchDomainData: 'fetchDomainData' }),

    showCreate() {
      this.comboFetchDomainData('manufacturers')
      this.localBrand = getInitialLocalBrand()
      this.localBrand.active = true
      this.imageLocal = []
      this.edit = false
      this.showSidebar = true
    },

    async show({ id, item } = {}) {
      if (!id && !item?.id) {
        this.showCreate()
      } else {
        if (id) {
          this.localBrandId = id
        }
        if (item) {
          this.localBrand = {
            ...item,
            manufacturerId: item.manufacturerId?.toString(),
          }
        }
        this.edit = true
        this.showSidebar = true
      }
    },

    hideSidebar() {
      this.localBrand = getInitialLocalBrand()
      this.localBrandId = null
      this.showSidebar = false
    },

    async saveBrand() {
      this.$refs.brandForm.showErrors()
      if (this.$refs.brandForm.isValid) {
        try {
          this.saving = true
          const [imageUploadResult] = await this.upload({
            files: this.imageLocal,
            destinationPath: 'images/productBrands',
          })

          if (imageUploadResult) {
            this.imageLocal = [this.getFileInstance(imageUploadResult.url)]
          }

          const body = {
            id: this.localBrand.id,
            apiId: this.localBrand.apiId,
            name: this.localBrand.name,
            image: imageUploadResult?.url,
            active: this.localBrand.active,
            manufacturerId: this.localBrand.manufacturerId,
          }
          const result = await this.$http({
            url: '/api/brands',
            method: this.edit ? 'PUT' : 'POST',
            data: body,
          })

          this.comboFetchDomainData('brands')
          this.showSuccess({
            message: this.$t(`${this.edit ? 'Atualização' : 'Inclusão'} realizada com sucesso`),
          })
          this.showSidebar = false
          this.$emit('save', result.data)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.saving = false
        }
      } else {
        this.showInvalidDataMessage()
      }
    },
  },
}
</script>

<style></style>
